<template>
  <FavouriteComponent />
</template>

<script>
// @ is an alias to /src
import FavouriteComponent from "@/components/Account/Pages/Favourite/Favourite.vue";

export default {
  name: "Orders",
  components: {
    FavouriteComponent
  }
};
</script>
